import { BackInStockConfiguration } from '../../../helpers/BackInStockConfiguration';
import { default as bemCssModules } from 'bem-css-modules';
import { NotifyTypeEnum } from '../helpers/NotifyTypeEnum';
import { default as NotifyTypeStyles } from './NotifyType.module.css';
import React from 'react';
import { useTranslationByKey } from '../../../helpers/useTranslationByKeys';
const style = bemCssModules(NotifyTypeStyles);
export const NotifyType = (props) => {
    const { isSmsSubscriptionEnabled } = BackInStockConfiguration.getConfig();
    const t = useTranslationByKey();
    const smsField = isSmsSubscriptionEnabled ? (React.createElement("div", { className: style('radio-box') },
        React.createElement("input", { checked: props.currentType === NotifyTypeEnum.sms, id: "pdp-notify-sms", name: "pdp-notify-choose", onChange: props.handleOnChange, type: "radio", value: NotifyTypeEnum.sms }),
        React.createElement("label", { htmlFor: "pdp-notify-sms" }, t('SMS')))) : null;
    return (React.createElement("div", { className: style() },
        React.createElement("div", { className: style('radio-box') },
            React.createElement("input", { checked: props.currentType === NotifyTypeEnum.email, id: "pdp-notify-email", name: "pdp-notify-choose", onChange: props.handleOnChange, type: "radio", value: NotifyTypeEnum.email }),
            React.createElement("label", { htmlFor: "pdp-notify-email" }, t('E-mail'))),
        smsField));
};
